export default "__VITE_ASSET__CyFmwomI__"